module.exports = __webpack_public_path__ + "img/app_login_top.46a99584.png";